const SET_SECTION = "SET_SECTION";
const INIT_SECTION = "INIT_SECTION";
const SET_TIMESHEET_APPROVAL = "SET_TIMESHEET_APPROVAL";

export function setSection(payload) {
  return {
    type: SET_SECTION,
    payload,
  };
}

export function initSection() {
  return {
    type: INIT_SECTION,
    payload: {},
  };
}

export function setTimesheetApproval(payload) {
  return {
    type: SET_TIMESHEET_APPROVAL,
    payload,
  };
}

const INIT_STATE = {
  /*section: {
    title: ''
  },
  menuLeft: {
    title: '',
    subMenuKey: '',
    menuKey: ''
  }*/
  section: {},
  menuLeft: {},
  timesheetApproval: null,
};

export default function sectionDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case SET_SECTION:
      newState.section = action.payload.section ? action.payload.section : state.section;
      newState.menuLeft = action.payload.menuLeft ? action.payload.menuLeft : state.menuLeft;
      break;
    case INIT_SECTION:
      newState.section = {};
      break;
    case SET_TIMESHEET_APPROVAL:
      newState.timesheetApproval = action.payload.timesheetApproval
        ? action.payload.timesheetApproval
        : state.timesheetApproval;
      break;
    default:
      /*
        If I'm here, the user change manually route or refresh page and now the state is empty.
        OPEN POINT: if I change manually route and I saved in local another sction, I see the old section and not the section of current page
      */
      //unused for now
      // newState = state;
      // if (newState.section.title === ''  && currentSection && currentSection !== '') {
      //     newState.section = JSON.parse(currentSection);
      // }
      break;
  }
  return newState;
}
